// extracted by mini-css-extract-plugin
export default {"Header":"index-module--Header--6f871"};